// from https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#image_types
const webSafeMime = new Set([
    'image/apng',
    'image/avif',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/webp',
]);

export function WebSafeMime(mime: string): boolean {
    return webSafeMime.has(mime.toLowerCase());
}